/**
 * This file is auto-generated
 */
export var ExperienceState;
(function (ExperienceState) {
    ExperienceState[ExperienceState["EXPERIENCE_STATE_UNSPECIFIED"] = 0] = "EXPERIENCE_STATE_UNSPECIFIED";
    ExperienceState[ExperienceState["STANDARD"] = 1] = "STANDARD";
    ExperienceState[ExperienceState["GENERATOR_PRO"] = 2] = "GENERATOR_PRO";
    ExperienceState[ExperienceState["GENERATOR_ORGANIZATION"] = 3] = "GENERATOR_ORGANIZATION";
    ExperienceState[ExperienceState["STANDARD_WEBMAIL"] = 4] = "STANDARD_WEBMAIL";
})(ExperienceState || (ExperienceState = {}));
export const userGatewayMethods = [
    'accountBasicInfo',
    'getAccountLimits',
];
//# sourceMappingURL=common-api.js.map